import { authentication } from "@microsoft/teams-js";

class AuthProvider {
    public getAuthToken() {
        return authentication.getAuthToken();
    }
}

export default new AuthProvider();
